import React from 'react';

import BarPagesChart from '../components/BarPagesChart';



const categories = [
	{
		value: '0-1',
		label: '0-1',
		color: '#367be2',
	},
	{
		value: '1-2',
		label: '1-2',
		color: '#367be2',
	},
	{
		value: '2-3',
		label: '2-3',
		color: '#367be2',
	},
	{
		value: '3-4',
		label: '3-4',
		color: '#367be2',
	},
	{
		value: '4-5',
		label: '4-5',
		color: '#367be2',
	},
	{
		value: '5-6',
		label: '5-6',
		color: '#367be2',
	},
	{
		value: '6-7',
		label: '6-7',
		color: '#367be2',
	},
	{
		value: '7-8',
		label: '7-8',
		color: '#367be2',
	},
	{
		value: '8-9',
		label: '8-9',
		color: '#367be2',
	},
	{
		value: '9-10',
		label: '9-10',
		color: '#367be2',
	},
];



type Props = {
	data: Array<{
		count: number;
		percentage: number;
		value: string;
	}>;
};

const RelevanceChart: React.FC<Props> = (props) => {
	const {
		data,
	} = props;

	const chartData = React.useMemo(
		() => {
			return categories.map((category) => {
				const item = data.find((item) => item.value === category.value);

				if (item) {
					return item;
				}

				return {
					count: 0,
					percentage: 0,
					value: category.value,
				};
			});
		},
		[
			data,
		]
	);

	return (
		<BarPagesChart
			categories={categories}
			data={chartData}
			name="relevance"
		/>
	);
};



export default React.memo(RelevanceChart);
